import { render } from "./LinkSetWidget.vue?vue&type=template&id=b5285a4a"
import script from "./LinkSetWidget.vue?vue&type=script&lang=js"
export * from "./LinkSetWidget.vue?vue&type=script&lang=js"

import "./LinkSetWidget.vue?vue&type=style&index=0&id=b5285a4a&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__